import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=bd74f3fe&scoped=true"
import script from "./taskInfo.vue?vue&type=script&lang=js"
export * from "./taskInfo.vue?vue&type=script&lang=js"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=bd74f3fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd74f3fe",
  null
  
)

export default component.exports